<script>
  import { onMount } from 'svelte';
  import {
    axios,
    widgetStore,
    groupStore,
    fatch,
  } from '../../../config.svelte';
  import { simplePopup } from '../../../components/simple-popup.svelte';
  import Layout from '../../../components/global/layout.svelte';
  import ManagerLayout from '../../../components/global/manager-content.svelte';
  import AddPropModal from '../../../components/global/modal/add-prop.svelte';
  import EditPropModal from '../../../components/modals/edit-prop.svelte';
  import AddWidgetModal from '../../../components/global/modal/name-desc.svelte';
  import EditWidgetModal from '../../../components/global/modal/name-desc.svelte';
  import PropsList from '../../../components/prop/props-list.svelte';
  import Button from '../../../components/global/button.svelte';
  import StringUtil from '../../../string-util.js';
  import UrlQueries from '../../../url-queries.js';

  let groups = [];
  let widgets = [];
  let widgetSelected;
  let addWidgetModalEvents = { callback: addWidget };
  let editWidgetModalEvents = { callback: editWidget };
  let addPropModalEvents = { callback: addProp };
  let editPropModalEvents = { callback: editProp };

  groupStore.subscribe(value => {
    groups = value;
  });
  widgetStore.subscribe(value => {
    widgets = value;
    if (!widgetSelected && widgets.length > 0) {
      widgetSelected = widgets[0];
    }
  });

  async function addWidget(data) {
    const result = await axios.send({
      url: '/widget',
      method: 'POST',
      data,
    });
    if (result.success === false) {
      simplePopup.error(result.error.response.data.message);
      return;
    }
    simplePopup.success('Widget added successfully!');
    widgetSelected = result.response.data.widget;
    widgetStore.update(value => {
      value.push(result.response.data.widget);
      return value;
    });
  }
  async function editWidget(data) {
    data.changes = {
      props: [],
    };
    const result = await axios.send({
      url: '/widget',
      method: 'PUT',
      data,
    });
    if (result.success === false) {
      simplePopup.error(result.error.response.data.message);
      return;
    }
    simplePopup.success('Group updated successfully!');
    widgetSelected = result.response.data.widget;
    widgetStore.update(value => {
      value.push(result.response.data.widget);
      return widgets.map(widget => {
        if (widget._id === result.response.data.widget._id) {
          return result.response.data.widget;
        }
        return widget;
      });
    });
    // widgets = widgets.map(widget => {
    //   if (widget._id === result.response.data.widget._id) {
    //     return result.response.data.widget;
    //   }
    //   return widget;
    // });
  }
  async function deleteWidget() {
    if (confirm('Are you sure you want to delete the Widget?\n\n')) {
      const result = await axios.send({
        url: `/widget/${widgetSelected._id}`,
        method: 'DELETE',
      });
      if (result.success === false) {
        simplePopup.error(result.error.response.data.message);
        return;
      }
      simplePopup.success('Group deleted successfully!');
      widgetStore.update(value => {
        return value.filter(e => e._id !== widgetSelected._id);
      });
      widgetSelected = widgets[0];
      // widgets = widgets.filter(e => e._id !== widgetSelected._id);
      // if (widgets.length > 0) {
      //   widgetSelected = widgets[0];
      // } else {
      //   widgetSelected = undefined;
      // }
    }
  }
  async function addProp(data) {
    const result = await axios.send({
      url: '/widget',
      method: 'PUT',
      data: {
        _id: widgetSelected._id,
        props: [...widgetSelected.props, data],
        changes: {
          props: [
            {
              name: {
                old: widgetSelected.name,
                new: widgetSelected.name,
              },
              required: false,
              add: data,
            },
          ],
        },
      },
    });
    if (result.success === false) {
      simplePopup.error(result.error.response.data.message);
      return;
    }
    simplePopup.success('Group updated successfully.');
    const widget = result.response.data.widget;
    widgetSelected = widget;
    widgetStore.update(value => {
      return value.map(e => {
        if (e._id === widget._id) {
          e = widget;
        }
      });
    });
  }
  async function editProp(originalName, data) {
    const changes = {
      props: [
        {
          name: {
            old: originalName,
            new: data.name,
          },
          required: data.required,
        },
      ],
    };
    const result = await axios.send({
      url: '/widget',
      method: 'PUT',
      data: {
        _id: widgetSelected._id,
        props: widgetSelected.props.map(e => {
          if (e.name === originalName) {
            return data;
          }
          return e;
        }),
        changes,
      },
    });
    if (result.success === false) {
      simplePopup.error(result.error.response.data.message);
      return;
    }
    simplePopup.success('Group updated successfully.');
    const widget = result.response.data.widget;
    widgetSelected = widget;
    widgetStore.update(value => {
      return value.map(e => {
        if (e._id === widget._id) {
          e = widget;
        }
      });
    });
  }
  async function deleteProp(prop, i) {
    const result = await axios.send({
      url: '/widget',
      method: 'PUT',
      data: {
        _id: widgetSelected._id,
        props: [...widgetSelected.props.filter(p => p.name !== prop.name)],
        changes: {
          props: [
            {
              name: {
                new: '',
                old: prop.name,
              },
              required: prop.required,
              remove: true,
            },
          ],
        },
      },
    });
    if (result.success === false) {
      simplePopup.error(result.error.response.data.message);
      return;
    }
    widgetSelected.props = widgetSelected.props.filter(
      p => p.name !== prop.name,
    );
    widgetStore.update(value => {
      return value.map(e => {
        if (e._id === widgetSelected._id) {
          e.props = widgetSelected.props;
        }
      });
    });
    simplePopup.success('Property deleted successfully!');
  }
  async function moveProp(position, data) {
    let found = false;
    if (position === 'up') {
      if (data.i > 0) {
        found = true;
        widgetSelected.props = widgetSelected.props.map((e, i) => {
          if (i === data.i) {
            return widgetSelected.props[i - 1];
          } else if (i === data.i - 1) {
            return data.prop;
          }
          return e;
        });
      }
    } else if (position === 'down') {
      if (widgetSelected.props[data.i + 1]) {
        found = true;
        widgetSelected.props = widgetSelected.props.map((e, i) => {
          if (i === data.i) {
            return widgetSelected.props[i + 1];
          } else if (i === data.i + 1) {
            return data.prop;
          }
          return e;
        });
      }
    }
    if (found === false) {
      simplePopup.error('Action cannot be performed.');
      return;
    }
    const result = await axios.send({
      url: '/widget',
      method: 'PUT',
      data: {
        _id: widgetSelected._id,
        props: [...widgetSelected.props],
        changes: {
          props: [],
        },
      },
    });
    if (result.success === false) {
      simplePopup.error(result.error.response.data.message);
      return;
    }
    const widget = result.response.data.widget;
    widgetSelected = widget;
    widgetStore.update(value =>
      widgets.map(e => {
        if (e._id === widget._id) {
          return widget;
        }
        return e;
      }),
    );
  }

  onMount(async () => {
    fatch();
    if (!widgetSelected && widgets.length > 0) {
      widgetSelected = widgets[0];
    }
  });
</script>

<Layout>
  <ManagerLayout
    items={widgets}
    itemSelected={widgetSelected}
    menuConfig={{ heading: 'WIDGETS', buttonLabel: 'Add new Widget' }}
    on:addNewItem={event => {
      if (event.eventPhase === 0) {
        addWidgetModalEvents.toggle();
      }
    }}
    on:itemClicked={event => {
      if (event.eventPhase === 0) {
        widgetSelected = event.detail;
      }
    }}
    on:addProp={event => {
      if (event.eventPhase === 0) {
        addPropModalEvents.toggle();
      }
    }}
    on:edit={event => {
      if (event.eventPhase === 0) {
        editWidgetModalEvents.set(widgetSelected.name, widgetSelected.desc);
        editWidgetModalEvents.toggle();
      }
    }}
    on:delete={event => {
      if (event.eventPhase === 0) {
        deleteWidget();
      }
    }}>
    {#if widgetSelected && widgetSelected.props.length > 0}
      <PropsList
        props={widgetSelected.props}
        {groups}
        on:remove={event => {
          if (event.eventPhase === 0) {
            deleteProp(event.detail.prop, event.detail.i);
          }
        }}
        on:edit={event => {
          if (event.eventPhase === 0) {
            editPropModalEvents.setProp(event.detail.prop, event.detail.i);
            editPropModalEvents.toggle();
          }
        }}
        on:moveUp={event => {
          if (event.eventPhase === 0) {
            moveProp('up', event.detail);
          }
        }}
        on:moveDown={event => {
          if (event.eventPhase === 0) {
            moveProp('down', event.detail);
          }
        }} />
    {:else}
      <div class="no-props">
        <div class="message">There are no properties yet</div>
        <div class="desc">Add your first to this Template</div>
        <div class="action">
          <Button
            icon={'fas fa-plus'}
            size={'small'}
            on:click={addPropModalEvents.toggle}>
            Add Property
          </Button>
        </div>
      </div>
    {/if}
  </ManagerLayout>
</Layout>

<AddWidgetModal
  title="Add new Widget"
  nameEncoding="_"
  events={addWidgetModalEvents}
  on:done={event => {
    if (event.eventPhase === 0) {
      addWidget({ name: event.detail.name, desc: event.detail.desc });
    }
  }} />
{#if widgetSelected}
  <AddPropModal
    usedPropNames={widgetSelected.props.map(e => {
      return e.name;
    })}
    {groups}
    events={addPropModalEvents}
    on:done={event => {
      if (event.eventPhase === 0) {
        addProp(event.detail);
      }
    }} />
  <EditPropModal
    selectedGroupId={undefined}
    usedPropNames={widgetSelected.props.map(e => {
      return e.name;
    })}
    {groups}
    events={editPropModalEvents} />
  <EditWidgetModal
    title="Edit Widget"
    nameEncoding="_"
    events={editWidgetModalEvents}
    on:done={event => {
      if (event.eventPhase === 0) {
        const widget = JSON.parse(JSON.stringify(widgetSelected));
        widget.name = event.detail.name;
        widget.desc = event.detail.desc;
        editWidget(widget);
      }
    }} />
{/if}
